// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Json_decode from "@glennsl/bs-json/src/Json_decode.bs.js";

function hitsArrayType(json) {
  var json$1 = Js_json.classify(json);
  if (typeof json$1 === "number") {
    return [];
  } else if (json$1.TAG === /* JSONArray */3) {
    return json$1._0.map(function (hit) {
                return {
                        objectID: Json_decode.field("objectID", Json_decode.string, hit),
                        title: Json_decode.field("title", Json_decode.string, hit),
                        created_at: Json_decode.field("created_at", Json_decode.string, hit),
                        url: Json_decode.field("url", Json_decode.string, hit),
                        author: Json_decode.field("author", Json_decode.string, hit),
                        points: Json_decode.field("points", Json_decode.$$int, hit),
                        num_comments: Json_decode.field("num_comments", Json_decode.$$int, hit)
                      };
              });
  } else {
    return [];
  }
}

function hitsData(data) {
  return {
          nbHits: Json_decode.field("nbHits", Json_decode.$$int, data),
          page: Json_decode.field("page", Json_decode.$$int, data),
          nbPages: Json_decode.field("page", Json_decode.$$int, data),
          hitsPerPage: Json_decode.field("hitsPerPage", Json_decode.$$int, data),
          hits: Json_decode.field("hits", hitsArrayType, data)
        };
}

function storyChildArrayType(json) {
  var json$1 = Js_json.classify(json);
  if (typeof json$1 === "number") {
    return [];
  } else if (json$1.TAG === /* JSONArray */3) {
    return json$1._0.map(function (child) {
                return {
                        id: Json_decode.field("id", Json_decode.$$int, child),
                        created_at: Json_decode.field("created_at", Json_decode.string, child),
                        author: Json_decode.optional((function (param) {
                                return Json_decode.field("author", Json_decode.string, param);
                              }), child),
                        text: Json_decode.optional((function (param) {
                                return Json_decode.field("text", Json_decode.string, param);
                              }), child),
                        children: Json_decode.field("children", storyChildArrayType, child)
                      };
              });
  } else {
    return [];
  }
}

function storyData(data) {
  return {
          id: Json_decode.field("id", Json_decode.$$int, data),
          author: Json_decode.field("author", Json_decode.string, data),
          created_at: Json_decode.field("created_at", Json_decode.string, data),
          title: Json_decode.field("title", Json_decode.string, data),
          points: Json_decode.field("points", Json_decode.$$int, data),
          url: Json_decode.field("url", Json_decode.string, data),
          children: Json_decode.field("children", storyChildArrayType, data)
        };
}

export {
  hitsArrayType ,
  hitsData ,
  storyChildArrayType ,
  storyData ,
  
}
/* No side effect */
